import React from "react"

import { cn } from "@/lib/utils"

interface BetaTagProps {
  className?: string
  /** Shown on hover. */
  title?: string
}

export const BetaTag: React.FC<BetaTagProps> = ({ className, title }) => (
  <span
    title={title}
    className={cn(
      "inline-flex items-center rounded border border-palette-skyBlue300 bg-palette-skyBlue100 px-1 text-[9px] font-semibold uppercase leading-4 tracking-wide text-palette-skyBlue800",
      className,
    )}
  >
    Beta
  </span>
)
